import React, { useEffect } from 'react';
import { useStore } from '../../../../../../stores/root';
import styles from './styles.module.scss';

// assets

// services

// props

// components
import { SpinnerSize, Stack } from '@fluentui/react';
import Text from '../../../../../typography/text';
import LoadingComponent from '../../../../../feedbacks/loading';
import Label from '../../../../../typography/label';
import GeneralService from '../../../../../../services/general';
import { IOutcomeResourceShorterProps } from '../../../../../../props/finance/outcomes';

type TotalOutcomeInvoicePendingAmountCardProps = {
    style?: any;
    grow?: number | boolean | "inherit" | "initial" | "unset" | undefined;
    variant?: 'primary' | 'default';
    invoices?: IOutcomeResourceShorterProps[];
}

const TotalOutcomeInvoicePendingAmountCard: React.FC<TotalOutcomeInvoicePendingAmountCardProps> = (props: TotalOutcomeInvoicePendingAmountCardProps) => {
    const { banner } = useStore();
    const [pendingAmount, setPendingAmount] = React.useState<number>();

    useEffect(() => {
        calculatePendingAmount();
    }, [props.invoices]);

    const calculatePendingAmount = () => {
        let totalAmount = 0;

        (props.invoices || []).forEach((invoice) => {
            totalAmount += Number(invoice.pendingPayment || '0');
        })

        setPendingAmount(totalAmount);
    }

    return <Stack grow={props.grow} tokens={{ childrenGap: 20 }} className={`${styles.card} ${styles.variant}`} style={props.style}>
        <Stack>
            <Label size={'small'}>Pending amount</Label>
        </Stack>
        <Stack>
            {!props.invoices ? <LoadingComponent labelPosition='right' label={'Retrieving ...'} spinnerPosition={'baseline'} size={SpinnerSize.small} /> : null}
            {props.invoices ? <>
                <Label className={'color-yellow'} size={'large'}>Rp. {GeneralService.getNumberWithSeparator(pendingAmount + '')}</Label>
            </> : null}
        </Stack>
    </Stack>;
};

export default TotalOutcomeInvoicePendingAmountCard;
